module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraLight.e59f0cc9.ttf";